import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import type { OfficeDesk } from './store'
import { useOfficeDesksStore } from '../officeDesks/store'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadOfficeDesk(id: string | number) {
  try {
    await useOfficeDesksStore().load()

    const officeDesk = useOfficeDesksStore().find(id)

    if (officeDesk) {
      return {
        status: 'success' as const,
        payload: officeDesk,
      }
    }

    throw new Error(`Office desk not found: ${id}`)
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function createOfficeDesk(inputData: any) {
  try {
    const url = withPbx('users')

    const { data } = await http.post<OfficeDesk>(url, inputData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function updateOfficeDesk(id: string | number, inputData: any) {
  try {
    const url = withPbx(`users/${id}`)

    const { data } = await http.put<OfficeDesk>(url, inputData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteOfficeDesk(id: string) {
  try {
    const url = withPbx(`users/${id}`)

    const { data } = await http.delete(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
